module.exports = __webpack_public_path__ + "static/img/logo_loading.a0a3ffc1.gif";